<template>
<div>
  <el-card  style="height: 98%;">
    <div slot="header">
      <el-row>
        <el-col :span="6">
          <!--
            1. 该页面分为只读模式(点「详情」进入)和设置模式(点「设置阶梯单价」进入)
            2. 只读模式下, 年份不可选
            3. 设置模式下, 任何年份都可选, 选择年份后, 自动加载相应年份的单价数据
              * 如果选择的年份早于当前年份, 则不可编辑
              * 如果选择的年份与当前年份相同, 则判断是否当前年份已经设置过单价(判断有无单价数据即可)
              * 如果选择的年份晚于当前年份, 则无论是否已经设置过单价, 都可以编辑
          -->
          <el-form
            label-position="right"
            label-width="80px"
            :inline="true"
            size="small">
            <el-form-item >
              <el-date-picker
                v-model="year"
                type="year"
                format="yyyy 年"
                value-format="yyyy"
                :editable="false"
                :clearable="false"
                :disabled="!ready || isViewMode"
                placeholder="选择年份">
              </el-date-picker>
            </el-form-item>
          </el-form>

        </el-col>
        <el-col :span="12">
          <el-alert
            v-show="ready && !havePricingDataInPickedYear"
            :title="`${year} 年没有设置阶梯单价`"
            type="warning"
            :closable="false"
            show-icon>
          </el-alert>

          <el-alert
            v-if="ready && havePricingDataInPickedYear && uplimitOfLastItem"
            :title="`若超出上限值 ${uplimitOfLastItem}, 单价计算规则以 ${pricingData[pricingData.length - 1].name} 为准`"
            type="info"
            show-icon
            :closable="false">
          </el-alert>
        </el-col>
      </el-row>
    </div>

    <el-row>
      <el-col>
        <stairstep-price
          ref="stairstepPrice"
          v-model="pricingData"
          :readonly="readonly">
        </stairstep-price>
      </el-col>
    </el-row>

    <div style="margin:32px 0 0 0px;">
      <el-button
        icon="el-icon-circle-check-outline"
        type="primary"
        @click="submit('stairstepPrice')"
        :disabled="readonly || edited">
        提交
      </el-button>
      <el-button icon="el-icon-arrow-left" @click="$router.back()">返回</el-button>
    </div>

  </el-card>
</div>
</template>

<script>
import {
  getPriceingDataByStairstep,
  setStairstepPrice
} from '@/apis/api'
import {PRICING_DATA_STAIRSTEP_MODIFIED} from '../topics'
import * as constants from '../constants'
import StairstepPrice from './components/stairstep-price'

export default {
  data() {
    return {
      ready: false,
      havePricingDataInPickedYear: false,
      edited: false,

      year: this.$route.query.year || new Date().getFullYear().toString(),

      pricingData: [],
      formList: [],
    }
  },
  computed: {
    isViewMode() {
      return !!this.$route.query.year
    },
    readonly() {
      if(this.isViewMode) {
        return true
      }
      let currentYear = new Date().getFullYear()
      if(this.year < currentYear) {
        return true
      } else if(this.year == currentYear) {
        return this.havePricingDataInPickedYear
      } else {
        return false
      }
    },
    // 最后一条规则的 uplimit 值
    uplimitOfLastItem() {
      if(this.pricingData && this.pricingData.length) {
        return this.pricingData[this.pricingData.length - 1].uplimit
      }
    }
  },
  watch: {
    year: {
      immediate: true,
      handler: 'fetchData'
    },
  },
  methods: {
    fetchData() {
      this.ready = false
      getPriceingDataByStairstep({year: this.year}).then(res => {
        let pricingData = (res.result && res.result.list && res.result.list[this.year]) || []
        this.havePricingDataInPickedYear = !!(pricingData && pricingData.length)
        this.pricingData = pricingData
        this.ready = true
      })
    },
    submit(refName) {
      this.$refs[refName].validate().then((valid) => {
        if(valid) {
          setStairstepPrice(
            {
              // data: encodeURIComponent(JSON.stringify(this.pricingData)),
              data: JSON.stringify(this.pricingData),
              year: this.year,
              userid: sessionStorage.getItem('userid')
            }
          ).then(res => {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.edited = true
            this.$bus.$emit(PRICING_DATA_STAIRSTEP_MODIFIED)
          }).catch(err => {
//          console.log(err)
            this.$message({
              message: '操作失败',
              type: 'danger'
            })
          })
        }
      })
    }
  },
  components: {
    StairstepPrice
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/sysmodule/waterfee/pricing/stairstep-edit.vue